/**
 * FAQ Accordion – Smooth open / close animation
 *
 * Native <details> removes content instantly on close (display:none),
 * making CSS transitions impossible for the closing direction.
 * This script intercepts clicks, adds .is-closing to trigger the
 * CSS reverse-transition, then removes [open] after it completes.
 */

(function () {
  var CLOSE_DURATION = 350; // ms — must match longest CSS transition

  function init() {
    document.querySelectorAll('.faq-item').forEach(function (details) {
      var summary = details.querySelector('.faq-summary');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault(); // stop native instant toggle

        if (details.classList.contains('is-closing')) return; // already animating

        if (details.open) {
          // ── CLOSE ──────────────────────────────────────────────
          // Add class → CSS overrides [open] styles → transition fires
          details.classList.add('is-closing');

          setTimeout(function () {
            details.open = false;
            details.classList.remove('is-closing');
          }, CLOSE_DURATION);

        } else {
          // ── OPEN ───────────────────────────────────────────────
          // Set open → browser makes content visible → CSS transition
          // from (max-height:0, opacity:0) to [open] state fires
          details.open = true;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
